module.exports = __webpack_public_path__ + "static/media/ArtworkE6Schedule2568.682757bb.png";